module.exports = itemmdmuiitemoverviewMfeConfig;